/* ---------------------------------------------------------------
   Lin & Lore - Kaching-lade in Australisch Engels (18-10-2026)

   De teksten van de Kaching Cart-lade staan in de Kaching-app nog in het
   Nederlands. Tot ze daar zijn aangepast, vertaalt dit script de zichtbare
   teksten in de lade. Kaching splitst zinnen over meerdere tekstnodes
   (vetgedrukte delen), dus de regels werken per losse node. Staan de
   teksten in de app al in het Engels, dan matcht niets en doet dit niets.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var REGELS = [
    [/(\d+\s?%)\s*korting/gi, '$1 off'],
    [/\s+off\s+op je hele bestelling/g, ' off your whole order'],
    [/^(\s*)op je hele bestelling/g, '$1your whole order'],
    [/op je hele bestelling/g, 'on your whole order'],
    [/\bis binnen\.\s*Nog\b/g, 'unlocked! Add'],
    [/^\s*Nog\b/g, 'Add'],
    [/\bartikelen erbij voor\b/g, 'more items for'],
    [/\bartikel erbij voor\b/g, 'more item for'],
    [/\bis binnen\b/g, 'unlocked'],
    [/Gratis verzending/g, 'Free shipping'],
    [/gratis verzending/g, 'free shipping'],
    [/\sen(\s*)$/g, ' and$1'],
    [/^(\s*)en\s/g, '$1and '],
    [/\s+en\s+(\d+\s?%)/g, ' and $1'],
    [/Je bespaart/g, 'You save'],
    [/Kortingen:/g, 'Discounts:'],
    [/Korting:/g, 'Discount:'],
    [/Totaal:/g, 'Total:'],
    [/Subtotaal:?/g, 'Subtotal'],
    [/Veilig afrekenen/g, 'Secure checkout'],
    [/Afrekenen/g, 'Checkout'],
    [/Je winkelwagen is leeg/g, 'Your cart is empty'],
    [/Verder winkelen/g, 'Continue shopping'],
    [/Winkelwagen/g, 'Your cart'],
    [/Verwijderen/g, 'Remove'],
    [/Gefeliciteerd!?/g, 'Congratulations!'],
    [/Je hebt\b/g, "You've unlocked"],
    [/\bontgrendeld\b/g, 'unlocked'],
    [/Maat:/g, 'Size:'],
    [/Kleur:/g, 'Colour:']
  ];

  function vertaal(node) {
    var v = node.nodeValue;
    if (!v || !/[a-z]/i.test(v)) return;
    var nieuw = v;
    for (var i = 0; i < REGELS.length; i++) nieuw = nieuw.replace(REGELS[i][0], REGELS[i][1]);
    if (nieuw !== v) node.nodeValue = nieuw;
  }

  function loop(root) {
    if (!root) return;
    if (root.nodeType === 3) { vertaal(root); return; }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) vertaal(n);
  }

  function inLade(el) {
    var e = el && (el.nodeType === 1 ? el : el.parentElement);
    return !!(e && e.closest && e.closest('kaching-cart, .kaching-cart'));
  }

  function start() {
    var lades = document.querySelectorAll('kaching-cart, .kaching-cart');
    for (var i = 0; i < lades.length; i++) loop(lades[i]);
    new MutationObserver(function (lijst) {
      for (var j = 0; j < lijst.length; j++) {
        var m = lijst[j];
        if (!inLade(m.target)) continue;
        if (m.type === 'characterData') { vertaal(m.target); continue; }
        for (var k = 0; k < m.addedNodes.length; k++) loop(m.addedNodes[k]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
